import { render, staticRenderFns } from "./i18n.vue?vue&type=template&id=c1164fc4"
import script from "./i18n.vue?vue&type=script&lang=js"
export * from "./i18n.vue?vue&type=script&lang=js"
import style0 from "./i18n.vue?vue&type=style&index=0&id=c1164fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports